module.exports = __webpack_public_path__ + "img/about2.9357855c.jpg";